import { LogLevel } from '@nts/std/src/lib/utility';

export const environment = {
  production: false,
  baseAppUrl: 'https://ntslanguage.ntsinformatica.it',
  authenticationAppUrl: 'https://ntsloginservice.ntsinformatica.it/auth/login',
  prefixApi: '/api',
  envType: 'DEV',
  appTitle: 'LanguageService - DEV',
  appSubTitle: '',
  logLevel: LogLevel.All,
  isEnterpriseBarrierRequired: false
};
